import { PrintBadgeButton } from '../../../../../ui/features/badge-management/components/AccountBadgeTable/PrintBadgeButton';
import { useAccountBadgeActions } from '../../../../../ui/features/badge-management/hooks/useAccountBadgeActions';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { MenuIconButton } from '@juvare/common-web-ui/MenuIconButton';
import BlockIcon from '@mui/icons-material/Block';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import MoreHorizIconOutlined from '@mui/icons-material/MoreHorizOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { Button, Stack } from '@mui/material';
import React from 'react';
import { stopEventPropagation } from '../../utils/stopEventPropagationHandler';
export const AccountBadgeActionsCell = ({ accountBadge, onActionSuccess }) => {
    const { t } = useBadgingTranslation();
    const actions = useAccountBadgeActions({
        accountBadge,
        onActionSuccess,
    });
    return (React.createElement(TextCell, null,
        React.createElement(Stack, { direction: 'row', gap: 1, justifyContent: 'flex-end' },
            actions.canPrint && (React.createElement(PrintBadgeButton, { accountBadge: accountBadge, onRefetch: onActionSuccess, startIcon: React.createElement(PrintOutlinedIcon, null), variant: 'text', size: 'small' })),
            actions.canNotify && (React.createElement(Button, { startIcon: React.createElement(CampaignOutlinedIcon, null), variant: 'text', size: 'small', onClick: stopEventPropagation(actions.handleAccountBadgeNotificationSend), sx: {
                    whiteSpace: 'nowrap',
                } }, t('badges.badgeDetails.accountBadgeTable.actions.notify'))),
            actions.canRevoke && (React.createElement(Button, { startIcon: React.createElement(BlockIcon, null), variant: 'text', size: 'small', onClick: stopEventPropagation(actions.handleAccountBadgeRevoke), sx: {
                    whiteSpace: 'nowrap',
                } }, t('badges.badgeDetails.accountBadgeTable.actions.revoke'))),
            actions.canReissue && (React.createElement(Button, { startIcon: React.createElement(PrintOutlinedIcon, null), variant: 'text', size: 'small', onClick: stopEventPropagation(actions.handleAccountBadgeReissue), sx: {
                    whiteSpace: 'nowrap',
                } }, t('badges.badgeDetails.accountBadgeTable.actions.reissue'))),
            React.createElement(MenuIconButton, { color: 'primary', size: 'small', menuItems: [
                    ...(actions.canEditDistributionStatus
                        ? [
                            {
                                label: t('badges.badgeDetails.accountBadgeTable.menuItems.changeDistributionStatus.menuItemLabel'),
                                onClick: actions.handleAccountBadgeDistributionStatusEdit,
                            },
                        ]
                        : []),
                    ...(actions.canEditExpirationDate
                        ? [
                            {
                                label: t('badges.badgeDetails.accountBadgeTable.menuItems.changeExpirationDate.menuItemLabel'),
                                onClick: actions.handleAccountBadgeExpirationDateEdit,
                            },
                        ]
                        : []),
                    {
                        label: t('badges.badgeDetails.accountBadgeTable.menuItems.history.menuItemLabel'),
                        onClick: actions.handleAccountBadgeHistoryOpen,
                    },
                ], anchor: 'right', stopPropagationOnClick: true, stopPropagationOnPointerDown: true },
                React.createElement(MoreHorizIconOutlined, null)))));
};
